import React, { useState, useEffect } from 'react';
import './App.css';
import { initializeApp } from 'firebase/app';
import { getAuth, signOut, onAuthStateChanged } from 'firebase/auth';
import { LoginPage } from './LoginPage';
import { AdminBackend } from './AdminBackend';
import { CustomerView } from './CustomerView';

const firebaseConfig = {
  apiKey: "AIzaSyCssPmZEr123f4QumVj8Uw-mZKPm4_L9pc",
  authDomain: "visualizer-f2095.firebaseapp.com",
  projectId: "visualizer-f2095",
  storageBucket: "visualizer-f2095.firebasestorage.app",
  messagingSenderId: "632056453495",
  appId: "1:632056453495:web:c22f700e14a66f5e06a972"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export default function App() {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setIsAdmin(currentUser?.email?.includes('admin'));
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    await signOut(auth);
    setUser(null);
    setIsAdmin(false);
  };

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  }

  if (!user) {
    return <LoginPage onLogin={() => {}} />;
  }

  return isAdmin ? <AdminBackend user={user} onLogout={handleLogout} /> : <CustomerView user={user} onLogout={handleLogout} />;
}
